module.exports = __webpack_public_path__ + "static/img/jzdwbLogoN.5806484.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jzdwbLogoN.jpg
// module id = +Nhq
// module chunks = 2